const columns = [
  {
    data: 'donation_amount',
    width: '30%',
  },
  {
    data: 'frequency',
    width: '20%',
  },
  {
    data: 'start_date',
    width: '20%',
  },
  {
    data: 'end_date',
    width: '20%',
  },
  {
    data: 'status',
    width: '10%',
    render: function(data, type, row, meta) {
      const getStatusClass = () => {
        if (data && data.toLowerCase() === 'active') {
          return 'accent'
        } else if (data && data.toLowerCase() === 'cancelled') {
          return 'red-100'
        } else if (data && data.toLowerCase() === 'paused') {
          return 'yellow-100'
        }
        return 'blue-100'
      }

      return `<span class="bold ${getStatusClass()} capitalize">${data || ''}</span>`
    },
  },
]

const headers = [
  'Amount', 
  'Frequency', 
  'Start Date', 
  'End Date', 
  'Status'
]

const filters = []

const sorters = [
  { column: 2, label: 'Start Date', order: 'desc' },
  { column: 0, label: 'Amount', order: 'desc' },
  { column: 1, label: 'Frequency', order: 'asc' },
  { column: 4, label: 'Status', order: 'asc' }
]

const order = [[ 2, "desc" ]]

export { columns, headers, filters, sorters, order }
